import { animate, state, style, transition, trigger } from '@angular/animations';

export const fadeInOut = trigger('fadeInOut', [
  state('in', style({ opacity: 1 })),
  transition(':enter', [style({ opacity: 0 }), animate(100)]),
  transition(':leave', animate(100, style({ opacity: 0 }))),
]);

export const carouselAnimation = trigger('carouselAnimation', [
  transition('void => *', [style({ opacity: 0 }), animate('200ms', style({ opacity: 1 }))]),
  transition('* => void', [animate('200ms', style({ opacity: 0 }))]),
]);

export const slideInOutAnimation = trigger('slideInOutAnimation', [
  state(
    'enter',
    style({
      left: '-100%',
      opacity: 0,
    }),
  ),
  state(
    'stable',
    style({
      left: '0%',
      opacity: 1,
    }),
  ),
  state(
    'leave',
    style({
      left: '-100%',
      opacity: 0,
    }),
  ),
  transition('enter => stable', [animate('0.5s ease-in-out')]),
  transition('stable => leave', [animate('0.5s ease-in-out')]),
  transition('leave => enter', [animate('0.5s ease-in-out')]),
]);

export const fadeInOutAnimation = trigger('fadeInOutAnimation', [
  state('enter', style({ opacity: 0 })),
  state('stable', style({ opacity: 1 })),
  state('leave', style({ opacity: 0 })),
  transition('enter => stable', [animate('0.5s ease-in-out')]),
  transition('stable => leave', [animate('0.5s ease-in-out')]),
]);
